import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Button} from '@ui/buttons/button';
import {Trans} from '@ui/i18n/trans';
import {useSelectedLocale} from '@ui/i18n/selected-locale';
import {useSettings} from '@ui/settings/use-settings';
import {useCookie} from '@ui/utils/hooks/use-cookie';
import clsx from 'clsx';
import {useMemo, useState} from 'react';
import {CustomMenuItem} from '../../menus/custom-menu';
import {localizePageAction} from '../../menus/use-custom-menu';

export function CookieNotice() {
  const {cookie_notice} = useSettings();

  const [, setCookie] = useCookie('cookie_notice');

  const [alreadyAccepted, setAlreadyAccepted] = useState(() => {
    return !getBootstrapData().show_cookie_notice;
  });

  if (!cookie_notice?.enable || alreadyAccepted) {
    return null;
  }

  return (
    <div
      className={clsx(
        'fixed z-50 flex w-full justify-center gap-14 bg-toast p-14 text-sm text-white shadow max-md:flex-col md:items-center md:gap-30',
        cookie_notice?.position == 'top' ? 'top-0' : 'bottom-0',
      )}
    >
      <Trans
        message="We use cookies to optimize site functionality and provide you with the
      best possible experience."
      />
      <InfoLink />
      <Button
        variant="flat"
        color="primary"
        size="xs"
        className="max-w-100"
        onClick={() => {
          setCookie('true', {days: 30, path: '/'});
          setAlreadyAccepted(true);
        }}
      >
        <Trans message="OK" />
      </Button>
    </div>
  );
}

function InfoLink() {
  const {cookie_notice} = useSettings();
  const {localeCode} = useSelectedLocale();

  // The configured button is a raw MenuItemConfig — it does NOT flow
  // through `useCustomMenu`, so without this rewrite the `action` is
  // whatever the admin typed (e.g. `/privacy-policy`) and the link
  // always points at the unprefixed (English-fallback) URL even when
  // the visitor is on /de/.... Apply the same per-locale rewrite that
  // configured menus use.
  const item = useMemo(() => {
    if (!cookie_notice?.button?.action) return cookie_notice?.button;
    const localizedAction = localizePageAction(
      cookie_notice.button.action,
      cookie_notice.button.type ?? '',
      localeCode,
    );
    return localizedAction === cookie_notice.button.action
      ? cookie_notice.button
      : {...cookie_notice.button, action: localizedAction};
  }, [cookie_notice?.button, localeCode]);

  if (!item?.label) {
    return null;
  }

  return (
    <CustomMenuItem
      className={() => 'text-primary-light hover:underline'}
      item={item}
    />
  );
}
